import React from 'react'

const RecycleIcon = () => {
  return (
    <svg 
        version="1.0" 
        xmlns="http://www.w3.org/2000/svg"
        width="20" 
        height="20" 
        viewBox="0 0 100.000000 100.000000"
        preserveAspectRatio="xMidYMid meet"
    >
        <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
        <path d="M443 980 c-31 -19 -153 -208 -153 -238 0 -36 40 2 87 83 103 175 142
        178 238 13 26 -46 54 -93 62 -105 13 -20 12 -23 -31 -48 -25 -15 -46 -33 -46
        -40 0 -15 198 -135 223 -135 15 0 17 15 17 135 0 153 -1 154 -75 111 l-41 -24
        -67 114 c-89 151 -137 181 -214 134z"/>
        <path d="M143 617 c-57 -34 -103 -68 -103 -74 0 -7 18 -24 40 -38 22 -14 40
        -28 40 -31 0 -3 -25 -48 -56 -100 -80 -136 -81 -198 -4 -237 48 -24 315 -21
        315 3 0 12 -25 16 -146 20 -215 7 -228 26 -132 191 32 55 61 99 66 99 5 0 29
        -12 53 -26 29 -17 49 -23 55 -17 5 5 8 65 7 139 -2 105 -6 129 -18 131 -8 1
        -61 -25 -117 -60z"/>
        <path d="M855 450 c-3 -5 17 -48 45 -95 62 -102 71 -142 40 -170 -19 -17 -39
        -20 -141 -23 l-119 -4 0 56 c0 30 -5 58 -11 61 -14 9 -224 -117 -224 -135 0
        -18 210 -144 224 -135 6 3 11 31 11 61 l0 54 110 0 c123 0 168 13 196 54 26
        41 13 94 -48 193 -53 86 -70 104 -83 83z"/>
        </g>
</svg>
  )
}

export default RecycleIcon